import script from "./Administrador.vue?vue&type=script&setup=true&lang=js"
export * from "./Administrador.vue?vue&type=script&setup=true&lang=js"

import "./Administrador.vue?vue&type=style&index=0&id=6f0ad8f9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f0ad8f9"]])

export default __exports__